import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { LobbyChannel } from '@/types/supabase';
import { Hash } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

interface ChannelListProps {
  channels: LobbyChannel[];
  loading: boolean;
}

const ChannelList: React.FC<ChannelListProps> = ({ channels, loading }) => {
  const { channelSlug } = useParams<{ channelSlug?: string }>();
  const activeSlug = channelSlug || 'general';

  return (
    <div className="p-4">
      <h2 className="text-lg font-semibold mb-2">Channels</h2>
      <nav className="space-y-1">
        {loading && (
          <>
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
          </>
        )}
        {!loading && channels.map((channel) => (
          <Link
            key={channel.id}
            to={`/lobby/${channel.slug}`}
            className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              activeSlug === channel.slug
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
            }`}
          >
            <Hash className="h-4 w-4" />
            <span>{channel.name}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default ChannelList;